import type { PatientPharmacyT } from '@lotushealth/lotushealth_js_sdk/schemas';

export function chooseDefaultPatientPharmacy(
  pharmacies: readonly PatientPharmacyT[]
): PatientPharmacyT | null {
  if (pharmacies.length === 0) {
    return null;
  }

  const primaries = pharmacies.filter((p) => p.IsDefault === true);
  const candidates = primaries.length > 0 ? primaries : pharmacies;

  const firstWithId =
    candidates.find((p) => p.PharmacyId != null && Number.isFinite(p.PharmacyId)) ?? null;
  return firstWithId ?? candidates[0] ?? null;
}
